import { render, staticRenderFns } from "./StarRatingDisplay.vue?vue&type=template&id=15db9878&"
import script from "./StarRatingDisplay.vue?vue&type=script&lang=js&"
export * from "./StarRatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports